export default class DataHelp {
  static getData(tableObj={}){
    let table_list=Object.keys(tableObj);
    let tb_list=[]
    let tb_len=5;
    table_list.forEach((item,index)=>{
      let items=[];
      let tb_fileds=Object.keys(tableObj[item]);
      tb_fileds.forEach((item_filed,index_filed)=>{
        items[index_filed]={
          "id": `${item}.${item_filed}`,
          "group": "list",
          "attrs": {
            "portNameLabel": {
              "text": item_filed
            },
            "portTypeLabel": {
              "text": tableObj[item][item_filed]['type']
            },
            "portPrimaryLabel": {
              "text": tableObj[item][item_filed]['primary']?'主键':''
            },
            "portCommentLabel": {
              "text": tableObj[item][item_filed]['comment']
            },
          }
        }
      })
      tb_list[index]={
        "position": {
          "x": index%tb_len*280,
          "y": Math.floor(index/tb_len)*400
        },
        "size": {
          "width": 250,
          "height": 24
        },
        "attrs": {
          "text": {
            "text": item
          }
        },
        "visible": true,
        "shape": "er-rect",
        "ports": {
          "groups": {
            "list": {
              "markup": [
                {
                  "tagName": "rect",
                  "selector": "portBody"
                },
                {
                  "tagName": "text",
                  "selector": "portNameLabel"
                },
                {
                  "tagName": "text",
                  "selector": "portTypeLabel"
                },
                {
                  "tagName": "text",
                  "selector": "portPrimaryLabel"
                },
                {
                  "tagName": "text",
                  "selector": "portCommentLabel"
                },
              ],
              "attrs": {
                "portBody": {
                  "width": 250,
                  "height": 24,
                  "strokeWidth": 1,
                  "stroke": "#5F95FF",
                  "fill": "#EFF4FF",
                  "magnet": true
                },
                "portNameLabel": {
                  "ref": "portBody",
                  "refX": 6,
                  "refY": 6,
                  "fontSize": 10
                },
                "portTypeLabel": {
                  "ref": "portBody",
                  "refX": 95,
                  "refY": 6,
                  "fontSize": 10
                },
                "portPrimaryLabel": {
                  "ref": "portBody",
                  "refX": 60,
                  "refY": 6,
                  "fontColor":"#ff0000",
                  "fontSize": 10
                },
                "portCommentLabel": {
                  "ref": "portBody",
                  "refX": 170,
                  "refY": 6,
                  "fontColor":"#ff0000",
                  "fontSize": 10
                }
              },
              "position": "erPortPosition"
            }
          },
          "items": items
        },
        "id": item,
        "zIndex": 1,
        "tools": {
          "items": [],
          "name": null
        }
      }
    })

    return tb_list;
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Database/common/DataHelp.js